import axios from 'axios';

export default {
    install: (Vue, options = {}) => {
        let token = '';
        if (options) {
            token =  options.token ? `Bearer ${options.token}` : ''
        }
        const axiosInstance = axios.create({
            baseURL: options?.baseUrl || '',
            headers: {
                'Authorization' : token,
                'Content-Type': "application/json",
                'Accept': "text/plain, */*",
            },
        });

        Vue.prototype.$axios = axiosInstance;

        if (!window) return

        Vue.mixin({
            beforeCreate() {
                const store = this.$options.store || (this.$parent && this.$parent.$options.store);
                axiosInstance.interceptors.request.use(async function (request) {
                    return request;
                },
                function (error) {
                    // Do something with the request error
                    return Promise.reject(error);
                }
                );

                axiosInstance.interceptors.response.use(
                    (response) => response,
                    (error) => {
                        // Do something with the response error
                        const {status} = error.response || {};

                        // Return a rejected Promise to prevent the error from propagating
                        return Promise.reject(error);
                    }
                );
            }
        })

    },
};

